import axios from 'axios';
import { get } from 'lodash-es';
import { from } from 'rxjs';
import { PAGE_SIZE_25, FIRST_PAGE } from '../../../services/pagination-service';

// TODO: The endpoints in these comments didn't get updated to the fulfillmentPlanSetGrid endpoint paradigm.
// if the user selects a handful of shipments inside the batch, you'll go the normal `/api/bulk/validateAddress` route, passing in the fulfillmentPlanIds as a collection
// if they wanna validate the entire batch, you can post to `/api/batch/bulk/validateAddress` and just give it the batchId(s)
// (and you'll get back a list of batchId + jobId pairs, because i do each batch in its own job)

const makeConfig = (page, pageSize, fulfillmentPlanSetGridTab, fulfillmentPlanSetGridOrderBy, searchTerm) => {
  const params = {
    page,
    pageSize,
    fulfillmentPlanSetGridTab,
    fulfillmentPlanSetGridOrderBy,
    searchTerm,
  };
  return params;
};

export const getBatchRows = (page, pageSize, selectedGridTab = 'open', sortBy, searchTerm) => {
  const params = makeConfig(page, pageSize, selectedGridTab, sortBy, searchTerm);
  const request = axios.get('/fulfillmentPlanSetGrid', { params }).then(({ data }) => data);

  const data$ = from(request);
  return data$;
};

export const getFilteredBatchRows = (
  pageNumber = FIRST_PAGE,
  pageSize = PAGE_SIZE_25,
  selectedGridTab = 'open',
  sortBy,
  searchTerm,
  apiFilter = {},
) => {
  const params = {
    page: { pageNumber, pageSize },
    FulfillmentPlanSetGridOrderBy: sortBy,
    filter: {
      searchTerm,
      FulfillmentPlanSetGridTab: selectedGridTab,
      ...apiFilter,
    },
  };

  const request = axios.post('/fulfillmentPlanSetGrid', { ...params }).then(({ data }) => data);

  const data$ = from(request);
  return data$;
};

export const archiveBatches = (fulfillmentPlanSetIds) => {
  const put = axios.put('/fulfillmentPlanSet/archive', {
    fulfillmentPlanSetIds,
  });
  const resp$ = from(put);
  return resp$;
};

export const createLabelsForBatches = (batchId, shipDate = new Date()) => {
  const post = axios
    .post('/bulk/create-labels-for-batch', {
      batchId,
      shipDate,
    })
    .then(({ data }) => data);

  const post$ = from(post);
  return post$;
};

export const validateBatches = (fulfillmentPlanSetId) => {
  const request = axios
    .post('/bulk/validate2', {
      fulfillmentPlanSetId,
      isLabelCreated: false,
    })
    .then((response) => {
      return get(response, 'data', undefined);
    });

  const data$ = from(request);
  return data$;
};

export const getCostReviewForBatch = (fulfillmentPlanSetId, excludedFulfillmentPlanId = [], hasAcceptedUpsLabelTerms) => {
  const params = hasAcceptedUpsLabelTerms != null ? { hasAcceptedUpsLabelTerms } : undefined;
  const request = axios
    .post(
      '/bulk/costReview',
      {
        fulfillmentPlanSetId,
        excludedFulfillmentPlanId,
        isLabelCreated: false,
      },
      { params },
    )
    .then((response) => {
      return get(response, 'data', undefined);
    });

  const data$ = from(request);
  return data$;
};

export const validateBatchesAddresses = (processFulfillmentPlanSet, fulfillmentPlanSetId, fulfillmentPlanIds) => {
  const batchRequestParams = {
    fulfillmentPlanSetId,
  };
  const bulkRequestParams = {
    fulfillmentPlanId: fulfillmentPlanIds,
  };
  const requestParams = processFulfillmentPlanSet ? batchRequestParams : bulkRequestParams;
  const request = axios.post('/bulk/validateaddress', requestParams).then((response) => {
    return get(response, 'data', undefined);
  });

  const data$ = from(request);
  return data$;
};

export const sendEmailForBatches = (fulfillmentPlanSetIds) => {
  const request = axios
    .post('/fulfillmentPlanSet/sendEmail', {
      fulfillmentPlanSetIds,
    })
    .then((response) => {
      return get(response, 'data', undefined);
    });

  const data$ = from(request);
  return data$;
};

export const sendNotificationsForBatches = (fulfillmentPlanSetIds) => {
  const request = axios
    .post('/fulfillmentPlanSet/sendNotifications', {
      fulfillmentPlanSetIds,
    })
    .then((response) => {
      return get(response, 'data', undefined);
    });

  const data$ = from(request);
  return data$;
};
